import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface AuthLayoutProps {
  brandSlot?: ReactNode
  footerSlot?: ReactNode
  children: ReactNode
  className?: string
}

export function AuthLayout({ brandSlot, footerSlot, children, className }: AuthLayoutProps) {
  return (
    <div
      className={cn(
        "min-h-screen bg-background flex flex-col items-center justify-center px-4 py-8",
        className,
      )}
    >
      {brandSlot && <div className="mb-6">{brandSlot}</div>}
      <div className="w-full max-w-[380px] bg-card border border-border rounded-lg p-8">
        {children}
      </div>
      {footerSlot && (
        <p className="text-caption text-muted-foreground mt-5">{footerSlot}</p>
      )}
    </div>
  )
}
